import service from '../api/role.concept.service';
//constants
const roleConcept = {
    roleConcepts: [],
    concepts: [],
    conceptsAssigned: [],
    roleConceptAdd: null,
    responseRoleConcept: null,
    errorRoleConcept: ''
}
//types
const LIST_ROLE_CONCEPT = 'LIST_ROLE_CONCEPT';
const ERROR_ROLE_CONCEPT = 'ERROR_ROLE_CONCEPT';
const ADD_ROLE_CONCEPT = 'ADD_ROLE_CONCEPT';
const UPDATE_ROLE_CONCEPT = 'UPDATE_ROLE_CONCEPT';
const DELETE_ROLE_CONCEPT = 'DELETE_ROLE_CONCEPT';
const CONCEPTS_NOT_ASSIGNED_BY_ROLE = 'CONCEPTS_NOT_ASSIGNED_BY_ROLE';
const CONCEPTS_ASSIGNED_BY_ROLE = 'CONCEPTS_ASSIGNED_BY_ROLE';

//reducer
export default function roleConceptReducer(state = roleConcept, action) {
    switch (action.type) {
        case LIST_ROLE_CONCEPT:
            return { ...state, roleConcepts: action.payload };
        case ADD_ROLE_CONCEPT:
            return { ...state, roleConceptAdd: action.payload };
        case ERROR_ROLE_CONCEPT:
            return { ...state, errorRoleConcept: action.payload };
        case CONCEPTS_NOT_ASSIGNED_BY_ROLE : 
        return {...state, concepts: action.payload};        
        case CONCEPTS_ASSIGNED_BY_ROLE : 
        return {...state, conceptsAssigned: action.payload};
        default:
            return { ...state };
    }
}

export const findConceptsNotAssigned = (roleId) => async (dispatch) => {    
    const response = await service.getConceptsNotAssigned(roleId).then((r) => {
        return r.data
    });

    let data = [];
    if (response != null) {
        if (response.code === undefined) {
            response.forEach((element) => {
                data.push({
                    value: element.Id,
                    label: element.name
                });
            });
        } else {
            dispatch({
                type: ERROR_ROLE_CONCEPT,
                payload: response.message
            });
        }
    }

    dispatch({
        type: CONCEPTS_NOT_ASSIGNED_BY_ROLE,
        payload: data
    });
    return data;
}

export const findConceptsAssigned = (roleId) => async (dispatch) => {
    const response = await service.getConceptsAssigned(roleId).then((r) => {
        return r.data
    });

    let data = [];
    if (response != null) {
        if (response.code === undefined) {
            response.forEach((element) => {
                data.push({
                    value: element.Id,
                    label: element.name
                });
            });
        } else {
            dispatch({
                type: ERROR_ROLE_CONCEPT,
                payload: response.message
            });
        }
    }

    dispatch({
        type: CONCEPTS_ASSIGNED_BY_ROLE,
        payload: data
    });
    return data;
}

export const findRoleConcept = (user, hasPermission, roleId) => async (dispatch) => {
    
    const response = await service.getRoleConcepts(user, hasPermission, roleId).then((r) => { return r.data });
    
    let data = [];
    if (response != null) {
        if (response.code === undefined) {
            response.forEach((element) => {
                data.push({
                    value: element.Id,
                    roleId: element.role.split("-")[0],
                    role: element.role.split("-")[1],
                });
            });
        } else {
            dispatch({
                type: ERROR_ROLE_CONCEPT,
                payload: response.message
            });
        }
    }
    dispatch({
        type: LIST_ROLE_CONCEPT,
        payload: data
    });

    return data;
}

export const findRoleConcepts = (user, hasPermission, roleId) => async (dispatch) => {
    const response = await service.getRoleConcepts(user, hasPermission, roleId).then((r) => {
        return r.data
    });

    dispatch({
        type: LIST_ROLE_CONCEPT,
        payload: response
    });
    return response;
}

export const saveRoleConcept = (roleConceptData) => async (dispatch) => {
    const response = await service.saveRoleConcept(roleConceptData).then((r) => { return r.data });
    dispatch({
        type: ADD_ROLE_CONCEPT,
        payload: response
    });
    return response;
}

export const updateRoleConcept = (roleConceptData) => async (dispatch) => {
    const response = await service.updateRoleConcept(roleConceptData).then((r) => { return r.data });

    dispatch({
        type: UPDATE_ROLE_CONCEPT,
        payload: response
    });
    return response;
}

export const deleteRoleConcept = (roleConcepts) => async (dispatch) => {
    const response = await service.deleteRoleConcept(roleConcepts).then((r) => { return r.data });

    dispatch({
        type: DELETE_ROLE_CONCEPT,
        payload: response
    });
    return response;
}